import React from 'react';
import { WineFilters } from './WineList';
import { Chip, Grid } from '@mui/material';
import { DeepCopy } from '../../Helper';

export interface WineChipsProps {
    wineFiltersAccessor: any
    refreshList: any
}

function WineChips(props: WineChipsProps) {
    const [wineFilters, setWineFilters] = props.wineFiltersAccessor;

    const removeType = (type: string) => {
        setWineFilters((_: WineFilters) => { _.types = _.types.filter(f => f != type); return DeepCopy(_) });
        props.refreshList();
    }

    const removeCharacteristic = (characteristic: string) => {
        setWineFilters((_: WineFilters) => { _.charactestics = _.charactestics.filter(f => f != characteristic); return DeepCopy(_) });
        props.refreshList();
    }

    return (
        <div>

            <div className='horizontal-scroll'>
                <div>
                    {
                        wineFilters.types.map((_: string) =>
                            <Chip className='ml-05 mr-05' label={_} variant="outlined" onDelete={() => removeType(_)} />)
                    }
                </div>
                <div>
                    {
                        wineFilters.charactestics.map((_: string) =>
                            <Chip className='ml-05 mr-05' label={_} variant="outlined" onDelete={() => removeCharacteristic(_)} />)
                    }
                </div>
            </div>
        </div>

    );
}

export default WineChips;